// extracted by mini-css-extract-plugin
module.exports = {"videos_section":"J3CBN","video_list":"IzISG","vdoactive":"bd1_h","border_color":"VL8ve","player_container_wrap":"ysu6N"};